import { Typography } from "@material-ui/core"
import _ from "lodash"
import { useTranslation } from "react-i18next"

const StatusColorBased = (props) => {
    const { t } = useTranslation()
    const { dataItem = {}, colorsArr = [], fieldMap = "",subfieldMap = "",isCustom= false } = props;
     let title = subfieldMap && fieldMap
    ? dataItem?.[fieldMap]?.[subfieldMap]
    : fieldMap 
    ? dataItem?.[fieldMap] 
    : ""
    
    return (
        <td>
            {isCustom ?
                <Typography
                    style={{
                        backgroundColor: _.find(colorsArr, { text: title })?.bg,
                        minWidth: "fit-content",
                        color: _.find(colorsArr, { text: title })?.textColor,
                        borderRadius: "4px",
                        textAlign: "center",
                        padding: "3px",
                        fontWeight: 600,
                        border: `1px solid ${_.find(colorsArr, { text: title })?.textColor}`,
                    }}
                >
                    {_.upperFirst(t(title))}
                </Typography>
                :
                <Typography
                    style={{
                        backgroundColor: _.find(colorsArr, { text: title })?.colorCode,
                        minWidth: "fit-content",
                        maxWidth: "100px",
                        color: "#FFF",
                        borderRadius: "4px",
                        textAlign: "center",
                        padding: "3px"
                    }}
                >{title}
                </Typography>
            }
        </td>
    )
}
export default StatusColorBased